module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Author",
      "src": "media/Author.JPG"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("It’s not difficult to see why Malcolm Tilsed is good at what he does. His enthusiasm for people and for detail is infectious. Malcolm is proud of the fact that he has been steeped in people management since he was a teenager. Born and raised in Poole, Dorset, he recalled how he left school at 16 on the Monday, joined Woolco’s department store in Bournemouth on the Tuesday and has carried on working in retail and shopping centre management ever since. Malcolm has worked all over the country and was courted to be centre manager at the NEW 02 arena in London. He moved to Ireland in 2018 but still offers a great wealth of knowledge to businesses from his online training company:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("www.greenboxmanagement.com. Malcolm is using his talents to write poetry about his real-life experience")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0